import { link } from "@/components/Action.tsx";
import { WButton } from "@/components/button/WButton.tsx";
import { InAdminContext } from "@/modules/main/adminContext.ts";
import BaseRouterRoot from "@/modules/main/BaseRouterRoot.tsx";
import { AuthenticatedRootProviders } from "@/modules/main/MainRoot.tsx";
import { userIsAdminAtom } from "@/modules/user/userApi.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import React from "react";
import { I18nProvider } from "react-aria";

const DefaultApolloProvider = React.lazy(() => import("@/admin/graphql/DefaultApolloProvider.tsx"));

/**
 * Force all currencies and date to be in English.
 *
 * Compared to "en-US", this locale has 24-hour time format and uses a short time zone suffix (eg. "EET").
 */
const adminLocale = "en-GB";

/** Root component for /admin routes */
function AdminProviders() {
    const isAdmin = useSuspenseQueryAtom(userIsAdminAtom);
    if (!isAdmin) {
        return (
            <div className="VStack items-center gap-2">
                <div>Only for administrative users</div>
                <WButton action={link({ to: "/" })}>Back to main app</WButton>
            </div>
        );
    }

    return (
        <InAdminContext.Provider value={true}>
            <DefaultApolloProvider>
                {/* This overrides the `I18nProvider` from the root (which has the user's chosen locale) */}
                <I18nProvider locale={adminLocale}>
                    <BaseRouterRoot chatEnabled={false} />
                </I18nProvider>
            </DefaultApolloProvider>
        </InAdminContext.Provider>
    );
}

function AdminRoot() {
    return (
        <AuthenticatedRootProviders>
            <AdminProviders />
        </AuthenticatedRootProviders>
    );
}

export default AdminRoot;
